const autoNgTemplateLoaderTemplate1 = require('./create-edge-stack-view.html');

import controller from './create-edge-stack-view.controller';

export const createEdgeStackView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
